"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
var parse_1 = require("../../helpers/parse");
function CheckAllDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/check-all.html',
        controller: /** @class */ (function (_super) {
            __extends(CheckAllController, _super);
            function CheckAllController($scope, book) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                var index = book.getIndex(_this.prefix, _this.id);
                _this.forms = _this.form.checkAllOptions.forms;
                _this.form.value = _this.form.getOptions()[index].case === 'true';
                _this.onCheck(_this.form.value);
                $scope.$watch(function () { return book; }, function () { return _this.onChange(); }, true);
                return _this;
            }
            CheckAllController.prototype.onCheck = function (check) {
                for (var _i = 0, _a = this.forms; _i < _a.length; _i++) {
                    var form = _a[_i];
                    var active = parse_1.evaluateCondition(form.condition, this.book);
                    if (active) {
                        var _b = form.id.split('.'), group = _b[0], id = _b[1];
                        var index = check ? form.checked : form.checked === 0 ? 1 : 0;
                        this.book.update(group, id, index);
                    }
                }
            };
            CheckAllController.prototype.onChange = function () {
                var allChecked = true;
                for (var _i = 0, _a = this.forms; _i < _a.length; _i++) {
                    var form = _a[_i];
                    var active = parse_1.evaluateCondition(form.condition, this.book);
                    if (active && this.getForeignValue(form.id) === 'false') {
                        allChecked = false;
                    }
                }
                if (this.form.value !== allChecked) {
                    this.form.value = allChecked;
                    var index = this.form.getOptions().findIndex(function (element) {
                        return (element.case === 'true') === allChecked;
                    });
                    this.book.update(this.prefix, this.id, index);
                }
            };
            CheckAllController.prototype.getForeignValue = function (key) {
                var _a = key.split('.'), group = _a[0], id = _a[1];
                return this.book.get(group, id) || '';
            };
            CheckAllController.prototype.setForeignValue = function () {
                //
            };
            return CheckAllController;
        }(form_1.FormOptionController)),
        controllerAs: 'checkAllCtrl'
    };
}
exports.CheckAllDirective = CheckAllDirective;
